if (!customElements.get('product-shorts')) {
  class ProductShorts extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.pdp__shorts-videos');
      this.videoMobileBtn = this.querySelector('.pdp__shorts-link');
      this.videoDesktopBtn = this.querySelector('.pdp__shorts-link-desktop');
      if (this.container ) {
        this.container.style.display = 'block';
      }
      const handleVideoBtnClick = (btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const videoId = btn.getAttribute('href').split('#')[1];
        const videoContainer = document.getElementById(videoId);
        if (videoContainer) {
        const videoContainerBody = videoContainer.querySelector('.pdp__accordion-body');
        const y = videoContainer.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: y, behavior: 'smooth' });
        videoContainer.classList.add('is-open');
        videoContainerBody.classList.remove('hidden');
        videoContainerBody.style.maxHeight = "max-content";
      }
      });
    };

    handleVideoBtnClick(this.videoMobileBtn);
    handleVideoBtnClick(this.videoDesktopBtn);
    }
    connectedCallback() {
      const settings = {
        slidesPerView: 3,
        spaceBetween: 16,
        freeMode: false,
        centerInsufficientSlides: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
          }
        },
        navigation: {
          nextEl: '.pdp__shorts-next',
          prevEl: '.pdp__shorts-previous',
        }
      }
      requirejs(['swiper'], (Swiper) => {
        this.swiper = new Swiper(this.container, settings);
      });
    }
  }

  customElements.define('product-shorts', ProductShorts);
}
